import React from "react";

const Service = () => {
  return (
    <React.Fragment>
      <img src="/static/service/service.png" alt="" />
    </React.Fragment>
  );
};

export default Service;
